

namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsPosStationDialog extends Serenity.EntityDialog<PsPosStationRow, any> {
        protected getFormKey() { return PsPosStationForm.formKey; }
        protected getIdProperty() { return PsPosStationRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosStationRow.localTextPrefix; }
        protected getNameProperty() { return PsPosStationRow.nameProperty; }
        protected getService() { return PsPosStationService.baseUrl; }
        protected getDeletePermission() { return PsPosStationRow.deletePermission; }
        protected getInsertPermission() { return PsPosStationRow.insertPermission; }
        protected getUpdatePermission() { return PsPosStationRow.updatePermission; }

        protected form = new PsPosStationForm(this.idPrefix);

        constructor() {
            super();

           // ดึงข้อมูลเมื่อเลือกshop ID

            this.form.ShopId.changeSelect2(e => {
                var shopId = Q.toId(this.form.ShopId.value);
                var sd : string = this.form.ShopId.value;

                console.log(sd)
                if (sd != null) {
                    console.log(PsShopRow.getLookup().itemById[sd].PromptPayLink)
                    this.form.PromptPayLink.value = PsShopRow.getLookup().itemById[sd].PromptPayLink;
                    this.form.QRCodeAccount.value = PsShopRow.getLookup().itemById[sd].QRCodeAccount;
                    
                }});

                this.form.ConnectEdcFg.changeSelect2(e => {
                    // var shopId = Q.toId(this.form.ConnectEdcFg.value);
                    var sd : string = this.form.ConnectEdcFg.value;
    
                    // console.log(sd)
                    if (sd == "1") {
                        Serenity.EditorUtils.setReadOnly(this.form.ConnectEdcPort, false);   
                        Serenity.EditorUtils.setReadOnly(this.form.EdcBank, false);                        

                    }else{
                        Serenity.EditorUtils.setReadOnly(this.form.ConnectEdcPort, true);
                        Serenity.EditorUtils.setReadOnly(this.form.EdcBank, true);
                    }
                
                });


            this.form.PsParaDefault1.change( e => {
                var isenableParsDefault1 = this.enableParsDefault1;
                var isdisableParsDefault1 = this.disableParsDefault1;

                Serenity.EditorUtils.setReadOnly(this.form.ShopLogoOnFrontScreen, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.ShopLogoOnReceipt, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptHeadMesg1, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptHeadMesg2, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptHeadMesg3, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptHeadMesg4, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptHeadMesg5, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptHeadMesg6, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg1, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg2, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg3, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg4, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg5, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg6, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg7, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg8, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg9, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptFootMesg10, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptNoBarcodeFg, !isdisableParsDefault1);
                Serenity.EditorUtils.setReadOnly(this.form.RecptNoBarcodeFg, !isdisableParsDefault1);
               
            });

            this.form.PsParaDefault2.change(e => {
                var isenableParsDefault2 = this.enableParsDefault2;
                var isdisableParsDefault2 = this.disableParsDefault2;

                Serenity.EditorUtils.setReadOnly(this.form.SelectSellingPriceFg, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.ReceiptPrinterType, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.SalesDocFg, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.SalesVatType, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.EjournalFg, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.NoOfRecptCopy, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.PrintOrderFg, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.PrintQueueFg, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.ItemOnRecptMethod, !isdisableParsDefault2);
                Serenity.EditorUtils.setReadOnly(this.form.RecptSumItemQtyFg, !isdisableParsDefault2);
            });
            this.form.AutoChargeFg.element.parent();
            this.form.AutoChargeFg.change(e=>{
                var atchangeN = this.autochangeN;
                var atchangeY = this.autochangeY;


                if (!atchangeY) {
                    Serenity.EditorUtils.setReadOnly(this.form.AutoChargeRate, !atchangeY);
                    return this.form.AutoChargeRate.value = 0;

                }
                else if (!atchangeN) {
                    Serenity.EditorUtils.setReadOnly(this.form.AutoChargeRate, atchangeN);
                    // return this.form.AutoChargeRate.value = ;

                }
            

            })

        }

        // private get isCopyAddress() {
        //     return this.form.CopyAddress.value != false;
        // }
        private get autochangeY() {
            return this.form.AutoChargeFg.value != "0";
        }
        private get autochangeN() {
            return this.form.AutoChargeFg.value != "1";
        }
        private get enableParsDefault1() {
            return this.form.PsParaDefault1.value != true;
        }

        private get disableParsDefault1() {
            return this.form.PsParaDefault1.value != false;
        }

        private get enableParsDefault2() {
            return this.form.PsParaDefault2.value != true;
        }

        private get disableParsDefault2() {
            return this.form.PsParaDefault2.value != false;
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();

            var PosId = Q.tryFirst(PosShift.PsPosShiftControlRow.getLookup().items, x => x.PosId == this.entity.PosId);
            if (PosId != null) {
                this.deleteButton.toggleClass('disabled', true);

            }

            var A = Q.tryFirst(PosShift.PsPosShiftControlRow.getLookup().items, x => x.PosId == this.entity.PosId && x.ShiftStatus == "O");
            console.log(A)
            console.log(this.entity.PosId)
            if (A != null) {
                
                // // Serenity.EditorUtils.setReadOnly(this.form.LastReceiptRunNo, true);        
                // // // this.form.LastReceiptRunNo.element.prop('updatable', false);
                // this.form.LastReceiptRunNo.getGridField().toggle(false);
                // // Serenity.EditorUtils.setReadOnly(this.form.LastRefundRunNo, true);
                // // // this.form.LastRefundRunNo.element.prop('updatable', false);    
                // this.form.LastRefundRunNo.getGridField().toggle(false);
            }

            if(this.isNew()){

            }else{
                var sd : string = this.form.ConnectEdcFg.value;    
                    // console.log(sd)
                    if (sd == "1") {
                        Serenity.EditorUtils.setReadOnly(this.form.ConnectEdcPort, false);                        
                    }else{
                        Serenity.EditorUtils.setReadOnly(this.form.ConnectEdcPort, true);
                    }
            }


        }
        // protected afterLoadEntity() {
        //     super.afterLoadEntity();

        //     var id = Q.first(Lookups.VwPsParaRow.getLookup().items, x => x.ShopName != null).Id;
        //     //console.log('id ='+id);
        //     Administration.PsParaService.Retrieve({
        //         EntityId: id
        //     }, response => {
        //         this.setDataDefaultPsPara(response.Entity);
        //     });

        //     this.deleteButton.hide();
        // }

        // private setDataDefaultPsPara(details: Administration.PsParaRow) {
        //     this.form.RecptHeadMesg1.value = details.ShopName;
        //     this.form.RecptHeadMesg2.value = details.RecptHeadMesg2;
        //     this.form.RecptHeadMesg3.value = details.RecptHeadMesg3;
        //     this.form.RecptHeadMesg4.value = details.RecptHeadMesg4;
        //     this.form.RecptHeadMesg5.value = details.RecptHeadMesg5;
        //     this.form.RecptHeadMesg6.value = details.RecptHeadMesg6;

        // }
    }
}